export default __webpack_public_path__ + "static/media/arrowDropdown.2657d56a.svg";